import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ImageGalleryComponent } from '../../../../shared/image-gallery/image-gallery.component';
import { NewsService } from '../../../../../services/news.service'
import { MatDialog } from '@angular/material/dialog';
import { NewsItemResource } from 'src/app/interfaces/news-item-resource';
import { Type } from 'src/app/enums/type.enum';
import { OverlayService } from 'src/app/services/overlay.service';
import { DatePipe } from '@angular/common';





@Component({
  selector: 'app-edit-news',
  templateUrl: './edit-news.component.html',
  styleUrls: ['./edit-news.component.scss']
})
export class EditNewsComponent implements OnInit {
  /**
   * dataForm
   */
  dataForm: UntypedFormGroup;
  /**
   * detailsForm
   */
  detailsForm: UntypedFormGroup;
  /**
   * descriptionForm
   */
  descriptionForm: UntypedFormGroup;
  /**
   * Will a new Image be uploaded
   */
  uploadImage: boolean = false;
  /**
   * Is the paged Loaded
   */
  finishedLoading: boolean = false;
  /***
   * The current NewsItemResource => set via URL
   */
  currentNewsItemResource: NewsItemResource = null;
  /**
   * ImageFormat
   */
  imageProperties = [
    { key: 'logo', value: null, hint: 'Format: 800 x 500, Typ: .png', hasChanged: false },
  ];
  /**
   * The Type of News
   */
  newsType = [
    { value: "NEWS", viewValue: "Nachricht" },
   // { value: "APPOINTMENT", viewValue: "Veranstalltung" },
  ]
  /**
   * The State of News
   */
  states = [
    { value: "NEW", viewValue: "Neu" },
    { value: "DRAFT", viewValue: "Entwurf" },
    { value: "PUBLISHED", viewValue: "Veröffentlicht" },
    { value: "ARCHIVED", viewValue: "Archiviert" },
  ]
  /**
   * The Visibility of News
   */
  visibilityType = [
    { value: "PUBLIC", viewValue: "Alle" },
    { value: "PRIVATE", viewValue: "Kunden" },
  ]
  /**
   * constructor
   * Init the Forms
   * @param route 
   * @param fb 
   * @param dialog 
   * @param newsService 
   * @param overlayService 
   * @param router 
   */
  constructor(
    private route: ActivatedRoute,
    private fb: UntypedFormBuilder,
    private dialog: MatDialog,
    private newsService: NewsService,
    private overlayService: OverlayService,
    private router: Router
  ) {
    this.dataForm = this.fb.group({
      image: [null, []],
      title: ['', [Validators.required]],
      type: ['NEWS', [Validators.required]],
      state: ['', [Validators.required]],
      visibility: ['', [Validators.required]],

    })

    this.detailsForm = this.fb.group({
      publishedDate: ['', [Validators.required]]
    })

    this.descriptionForm = this.fb.group({
      description: ['', [Validators.required]],
      content: ['', []]
    })
  }
  /**
   * Get the NewsItem via the URL
   */
  ngOnInit(): void {
    this.route.params.subscribe(params => {
      this.newsService.getOneNews(params['id'])
        .subscribe(
          (val: NewsItemResource) => {
            this.currentNewsItemResource = val;
            console.log(val)
            this.dataForm.patchValue({
              image: val.image,
              title: val.title,
              type: val.type,
              state: val.state,
              visibility: val.visibility,
            })
            this.descriptionForm.patchValue({
              description: val.description,
              content: val.content
            })

            this.detailsForm.patchValue({
              publishedDate: this.formatDate(this.currentNewsItemResource.publishedDate),
            })

            if (val.type == Type.APPOINTMENT) {
              this.changeForm(val)
              this.detailsForm.patchValue({
                fromDate: this.formatDate(this.currentNewsItemResource.fromDate),
                untilDate: this.formatDate(this.currentNewsItemResource.untilDate),
                street: val.address.street,
                city: val.address.city,
                postcode: val.address.postcode
              })
            }
            this.finishedLoading = true;
          },
          error => {
            console.log("error: ", error);
            this.overlayService.openErrorDialog("Fehler beim Laden", "Versuchen Sie es bitte später noch einmal. Sollte das Problem nicht in absehbarer Zeit behoben sein, schreiben Sie uns eine E-Mail an: support@plusservices.de", "Zurück")
          }
        );
    })
  }
  /**
   * Edit a newsitem
   * @returns 
   */
  editNewsItem() {
    this.dataForm.markAllAsTouched();
    this.detailsForm.markAllAsTouched();
    this.descriptionForm.markAllAsTouched();
    if (this.dataForm.invalid || this.detailsForm.invalid || this.descriptionForm.invalid) {
      return;
    }

    this.currentNewsItemResource.image = this.dataForm.value.image;
    this.currentNewsItemResource.title = this.dataForm.value.title;
    this.currentNewsItemResource.state = this.dataForm.value.state;
    this.currentNewsItemResource.type = this.dataForm.value.type;
    this.currentNewsItemResource.visibility = this.dataForm.value.visibility;
    this.currentNewsItemResource.description = this.descriptionForm.value.description;
    this.currentNewsItemResource.content = this.descriptionForm.value.content;
    this.currentNewsItemResource.publishedDate = this.detailsForm.value.publishedDate;

    // if (this.dataForm.value.type == 'APPOINTMENT') {
    //   this.currentNewsItemResource.address = {
    //     street: this.detailsForm.value.street,
    //     postcode: this.detailsForm.value.postcode,
    //     city: this.detailsForm.value.city
    //   }
    // }

    this.newsService.editNews(this.currentNewsItemResource).subscribe(fromEdit => {
      this.overlayService.openSnackBar("Info-Eintrag erfolgreich bearbeitet!");
      this.router.navigate(["caseworker/news"],{
        queryParams: {
          "filterByStates": "DRAFT,PUBLISHED",
          "filterByTypes": "NEWS",
          "filterByVisibility":"PUBLIC,PRIVATE"
        },
      });
    })
  }

  /**
   * Update the Form base on the Type passed in
   * @param val 
   */
  changeForm(val?: NewsItemResource) {
    // if (this.dataForm.value.type == 'APPOINTMENT') {
    //   this.detailsForm.addControl('street', new UntypedFormControl('', ));
    //   this.detailsForm.addControl('city', new UntypedFormControl('', ));
    //   this.detailsForm.addControl('postcode', new UntypedFormControl('', ));
    //   this.detailsForm.addControl('fromDate', new UntypedFormControl('', Validators.required));
    //   this.detailsForm.addControl('untilDate', new UntypedFormControl('', Validators.required));
    //   if (val) {
    //     this.detailsForm.patchValue({
    //       street: val.address?.street,
    //       city: val.address?.city,
    //       postcode: val.address?.postcode,
    //       untilDate: val?.untilDate,
    //       fromDate: val?.fromDate
    //     })
    //   }
    // } else {
      this.detailsForm.removeControl('street');
      this.detailsForm.removeControl('city');
      this.detailsForm.removeControl('postcode');
      this.detailsForm.removeControl('fromDate');
      this.detailsForm.removeControl('untilDate');
  //  }
  }
  /**
   * Open the Gallery to let the user select an Image 
   * @param property 
   */
  openImageGallery(property) {
    const dialogRef = this.dialog.open(ImageGalleryComponent);
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        console.log(result)
        this.dataForm.patchValue({
          image: {
            deprecation: null,
            href: result?.url,
            hreflang: null,
            media: null,
            rel: "image",
            title: result?.title,
            type: result?.type,
          }
        })
        property.value = result.url;
        property.hasChanged = true;
        property.newValue = `${result.clientRef}/attachment/${result.publicId}`;
        this.uploadImage = true;
      }
    });
  }

  /**
   * Formate the Date to YYYY-MM-DD
   * @param date 
   * @returns 
   */
  private formatDate(date) {
    const d = new Date(date);
    let month = '' + (d.getMonth() + 1);
    let day = '' + d.getDate();
    const year = d.getFullYear();
    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;
    return [year, month, day].join('-');
  }
}
